import { GetAllElementsOutDto, GetAllElementsInDto } from '../../../types/element.dto'

export const GET_ALL_ELEMENTS = 'GET_ALL_ELEMENTS'
export const GET_ALL_ELEMENTS_SUCCESS = 'GET_ALL_ELEMENTS_SUCCESS'
export const GET_ALL_ELEMENTS_ERROR = 'GET_ALL_ELEMENTS_ERROR'
export const RESET_GET_ALL_ELEMENTS = 'RESET_GET_ALL_ELEMENTS'
export const UPDATE_ALL_CURRENT_ELEMENTS = 'UPDATE_ALL_CURRENT_ELEMENTS'

export interface GetAllElements<T> {
  type: typeof GET_ALL_ELEMENTS
  payload: GetAllElementsOutDto<T>
}

export interface GetAllElementsSuccess<T> {
  type: typeof GET_ALL_ELEMENTS_SUCCESS
  payload: GetAllElementsInDto<T>
}

export interface GetAllElementsError {
  type: typeof GET_ALL_ELEMENTS_ERROR
  payload: string | boolean
}

export interface ResetGetAllElements {
  type: typeof RESET_GET_ALL_ELEMENTS
  payload: null
}

export interface UpdateAllCurrentElements {
  type: typeof UPDATE_ALL_CURRENT_ELEMENTS
  payload: GetAllElementsInDto<any>
}

export interface State<T> {
  data: GetAllElementsInDto<T> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

// Define una función que acepte un parámetro T y devuelva un initialState con ese tipo T
const createInitialState = <T>(): State<T> => {
  return {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  };
};

// Ahora puedes usar esta función para inicializar el estado con el tipo T que necesites
export const initialState = createInitialState<any>();

export type Actions<T> = GetAllElements<T> | GetAllElementsSuccess<T> | GetAllElementsError | ResetGetAllElements | UpdateAllCurrentElements
